import styled from 'styled-components'


export const Container = styled.div`
  width: 100%;
  padding-top: 16px;
  padding-inline: 16px;
`
export const Form = styled.div`
  gap: 16px;
  display: flex;
  flex-direction: row;
`
export const WrapperForm = styled.div`
  flex: 1;
  padding-bottom: 8px;
`
export const WrapperButton = styled.div`
  gap: 8px;
  display: flex;
  justify-content: flex-end;
  padding-top: 8px;
`
export const Label = styled.label`
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  color: #484848;
`
export const Asterisk = styled.span`
  font-weight: 600;
  font-size: 12px;
  color: #FF0303;
`